
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppButton } from '@/components';
import { useSysRoleAdd } from '@/modules/role/system/model/add';
import { ROUTE_NAME_ROLE } from '@/modules/role/router';

export default defineComponent({
    name: ROUTE_NAME_ROLE.SYSTEM.ADD,
    components: { AppFormRow, AppInput, AppSelect, AppButton, AppCard },
    setup() {
        const { model, v$, addRole, roleOption } = useSysRoleAdd();

        return { v$, model, addRole, roleOption };
    }
});
